import { render, staticRenderFns } from "./RecoveryTextInput.vue?vue&type=template&id=3c3d4a3a&scoped=true"
import script from "./RecoveryTextInput.vue?vue&type=script&lang=js"
export * from "./RecoveryTextInput.vue?vue&type=script&lang=js"
import style0 from "./RecoveryTextInput.vue?vue&type=style&index=0&id=3c3d4a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3d4a3a",
  null
  
)

export default component.exports